import styled from 'styled-components';

import { COLORS } from '@treelab/panda';

export const Cnotainer = styled.div`
  margin-top: 31px;
  display: flex;
  align-items: center;
  color: ${COLORS.greyDark1};
  font-size: 14px;
  line-height: 20px;
`;

export const Vertical = styled.div`
  margin-right: 13px;
  width: 1px;
  height: 14px;
  border: 1px solid ${COLORS.greyLight2};
  background-color: ${COLORS.greyLight2};
`;
